import React from 'react';
import PropTypes from 'prop-types';
import Message from '../detail/Message';

export default class MessagesList extends React.Component {

    render() {
        const {
            data,
            error,
            canResponseMessage,
        } = this.props;

        if ( error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{error}</h3>
                </section>
            );
        }

        return (
            <div>
                {
                    data.map((message) => {
                            return <Message
                                key={message.id()}
                                message={message}
                                canResponse={canResponseMessage}
                                canArchive={canResponseMessage}
                                showDivider={true}
                            />;
                        },
                    )
                }
            </div>
        );
    }

}

MessagesList.propTypes = {
    data: PropTypes.arrayOf(PropTypes.any).isRequired,
    error: PropTypes.string,
    canResponseMessage: PropTypes.bool,
};

MessagesList.defaultProps = {
    error: '',
    canResponseMessage: true,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/card/MessagesList.js